import {
  FACILITATOR_VALIDATION_CLEAR,
  FACILITATOR_VALIDATION_CLEAR_FILTERS,
  FACILITATOR_VALIDATION_SET_SELECTED_FILTER_BY_CUSTOMER,
  FACILITATOR_VALIDATION_SET_SELECTED_FILTERS,
} from '../../../../../actions/actionTypes';
import { castFunctionHelper } from '../../helpers/filterHelpers';

const defaultState = true;
const key = 'filterByCustomer';

const filterByCustomer = (state = defaultState, action) => {
  switch (action.type) {
    case FACILITATOR_VALIDATION_CLEAR:
    case FACILITATOR_VALIDATION_CLEAR_FILTERS:
      return defaultState;

    case FACILITATOR_VALIDATION_SET_SELECTED_FILTER_BY_CUSTOMER:
    case FACILITATOR_VALIDATION_SET_SELECTED_FILTERS:
      return castFunctionHelper(key, defaultState, action);

    default:
      return state;
  }
};

export default filterByCustomer;
